import { isAddressEqual } from '../../helpers/isAddressEqual';
import { isCloud } from '../../helpers/isCloud';
import { defaultEmployeeAddress } from './FiasOverrider.constants';
export const getForeingAddress = ({ postalCode, addressString, countryFullName, }) => {
    let result = addressString;
    if (!result) {
        return;
    }
    if (postalCode) {
        result = result.replace(postalCode, '');
    }
    if (countryFullName) {
        result = result.replace(countryFullName, '');
    }
    return result.replace(/^[,\s,]{0,}/, '');
};
export const getFiasApiUrl = () => {
    return isCloud() ? 'https://api.testkontur.ru/fias/v1.2/' : 'https://api.kontur.ru/fias/v1.2/';
};
export const isDefaultAddress = (address) => {
    return isAddressEqual(defaultEmployeeAddress, address);
};
